import React from 'react'
import { LangSteps53 } from '../../../constant/languange'
import Content from '../Content'

const Fifth3 = (props) => {
  const data = {
    title: '',
    steps: [LangSteps53],
    button: 'Mulai Atur Lokasi Kehadiran',
    nextStep: 6,
    skipTo: '/company/setting',
    isDone: props.stats.spots_count
  }

  return <Content {...props} data={data} />
}

export default Fifth3
